<div class="dashboard-container">
    <div class="accordion_section tabs">
        <mat-tab-group
            [(selectedIndex)]="selectedTabIndex"
            (selectedTabChange)="onTabChange()"
        >
            <mat-tab>
                <ng-template mat-tab-label>
                    <div class="d-flex align-items-center">
                        <span>Mentor View</span>
                    </div>
                </ng-template>
                <div class="view-content">
                    <div class="header-section">
                        <div class="header">
                            Mentee Summary
                        </div>
                        <div class="search">
                            <input
                                type="text"
                                placeholder="Search For Trainings, Mentee Name etc..."
                                [(ngModel)]="mentorSearchQuery"
                                (keyup.enter)="searchMentorsView()"
                                (keyup)="updateSearchQuery($event, true)"
                            />
                            <span
                                style="transform: translate(-65px, 11px);"
                                class="material-symbols-outlined"
                                (click)="clearSearch($event, true)"
                                *ngIf="mentorSearchQuery"
                            >
                                close
                            </span>
                            <span
                                class="material-symbols-outlined search-icon"
                                (click)="searchMentorsView()"
                            > search </span>
                        </div>
                        <div class="export">
                            <button (click)="exportTrainingData(true)">
                                <i class="iconplus mr-1">
                                <span class="material-symbols-outlined"> download </span>
                                </i>
                                <span class="btn-create"> Export</span>
                            </button>
                        </div>
                    </div>
                    <div class="table-section">
                        <mat-table [dataSource]="mentorViewDataSource">
                            <ng-container matColumnDef="menteeName">
                                <mat-header-cell *matHeaderCellDef> Mentee Name </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <div
                                        class="mat-cell truncateValue"
                                        [ngbTooltip]="projectNameTooltip"
                                        tooltipClass="custom_tooltip"
                                        triggers="manual"
                                        #tooltip="ngbTooltip"
                                        (mouseleave)="tooltip.close()"
                                        (mouseover)="tooltip.open()"
                                    >
                                        <ng-template #projectNameTooltip class="custom_tooltip">
                                            {{ element.menteeName }}
                                        </ng-template>
                                        {{ element.menteeName }}
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="trainingName">
                                <mat-header-cell *matHeaderCellDef> Training Name </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <div
                                        class="mat-cell truncateValue"
                                        [ngbTooltip]="projectNameTooltip"
                                        tooltipClass="custom_tooltip"
                                        triggers="manual"
                                        #tooltip="ngbTooltip"
                                        (mouseleave)="tooltip.close()"
                                        (mouseover)="tooltip.open()"
                                    >
                                        <ng-template #projectNameTooltip class="custom_tooltip">
                                            {{ element.trainingName }}
                                        </ng-template>
                                        {{ element.trainingName }}
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="menteeHours">
                                <mat-header-cell *matHeaderCellDef> Mentee Hours </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <div
                                        class="mat-cell truncateValue"
                                        [ngbTooltip]="projectNameTooltip"
                                        tooltipClass="custom_tooltip"
                                        triggers="manual"
                                        #tooltip="ngbTooltip"
                                        (mouseleave)="tooltip.close()"
                                        (mouseover)="tooltip.open()"
                                    >
                                        <ng-template #projectNameTooltip class="custom_tooltip">
                                            {{ element.menteeHours }}
                                        </ng-template>
                                        {{ element.menteeHours }}
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="mentorHours">
                                <mat-header-cell *matHeaderCellDef> Mentor Hours </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <div
                                        class="mat-cell truncateValue"
                                        [ngbTooltip]="projectNameTooltip"
                                        tooltipClass="custom_tooltip"
                                        triggers="manual"
                                        #tooltip="ngbTooltip"
                                        (mouseleave)="tooltip.close()"
                                        (mouseover)="tooltip.open()"
                                    >
                                        <ng-template #projectNameTooltip class="custom_tooltip">
                                            {{ element.mentorHours }}
                                        </ng-template>
                                        {{ element.mentorHours }}
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="completedStatus">
                                <mat-header-cell *matHeaderCellDef> % Completed </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <div
                                        class="mat-cell truncateValue"
                                        [ngbTooltip]="projectNameTooltip"
                                        tooltipClass="custom_tooltip"
                                        triggers="manual"
                                        #tooltip="ngbTooltip"
                                        (mouseleave)="tooltip.close()"
                                        (mouseover)="tooltip.open()"
                                    >
                                        <ng-template #projectNameTooltip class="custom_tooltip">
                                            {{ element.completedPercentage }}
                                        </ng-template>
                                        {{ element.completedPercentage }}
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="status">
                                <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <div
                                        class="mat-cell truncateValue"
                                        [ngbTooltip]="projectNameTooltip"
                                        tooltipClass="custom_tooltip"
                                        triggers="manual"
                                        #tooltip="ngbTooltip"
                                        (mouseleave)="tooltip.close()"
                                        (mouseover)="tooltip.open()"
                                    >
                                        <ng-template #projectNameTooltip class="custom_tooltip">
                                            {{ element.status }}
                                        </ng-template>
                                        {{ element.status }}
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="startDate">
                                <mat-header-cell *matHeaderCellDef> Start Date </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <div
                                        class="mat-cell truncateValue"
                                        [ngbTooltip]="projectNameTooltip"
                                        tooltipClass="custom_tooltip"
                                        triggers="manual"
                                        #tooltip="ngbTooltip"
                                        (mouseleave)="tooltip.close()"
                                        (mouseover)="tooltip.open()"
                                    >
                                        <ng-template #projectNameTooltip class="custom_tooltip">
                                            {{ element.startDate }}
                                        </ng-template>
                                        {{ element.startDate }}
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="endDate">
                                <mat-header-cell *matHeaderCellDef> End Date </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <div
                                        class="mat-cell truncateValue"
                                        [ngbTooltip]="projectNameTooltip"
                                        tooltipClass="custom_tooltip"
                                        triggers="manual"
                                        #tooltip="ngbTooltip"
                                        (mouseleave)="tooltip.close()"
                                        (mouseover)="tooltip.open()"
                                    >
                                        <ng-template #projectNameTooltip class="custom_tooltip">
                                            {{ element.endDate }}
                                        </ng-template>
                                        {{ element.endDate }}
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="actions">
                                <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <a class="action-link" (click)="openLogHoursDialog(true, element)">
                                        <span class="material-symbols-outlined"> edit </span> Log Hours
                                    </a>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="mentorViewColumns; sticky: true"></mat-header-row>
                            <mat-row
                                [class.odd]="i % 2 == 1"
                                [class.even]="i % 2 == 0"
                                *matRowDef="let row; columns: mentorViewColumns; let i = index;"
                            >
                            </mat-row>
                        </mat-table>

                        <div
                            *ngIf="!mentorViewDataSource.length && !isMentorViewLoading"
                            style="text-align: center; margin: 10px 0;"
                        >
                            No Records Found
                        </div>
                        <mat-paginator
                            #mentorPaginator
                            [length]="filteredMentorViewList.length"
                            [pageSize]="mentorViewTo"
                            [pageSizeOptions]="[10, 20, 50, 100]"
                            (page)="onPageChange($event, true)"
                        ></mat-paginator>
                    </div>
                </div>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                  <div class="d-flex align-items-center">
                    <span>Mentee View</span>
                  </div>
                </ng-template>
                <div class="mentor-view-content">
                    <div class="header-section">
                        <div class="header">
                            Training Summary
                        </div>
                        <div class="search">
                            <input
                                type="text"
                                placeholder="Search For Trainings, Mentor Name etc..."
                                [(ngModel)]="menteeSearchQuery"
                                (keyup.enter)="searchMenteesView()"
                                (keyup)="updateSearchQuery($event, false)"
                            />
                            <span
                                style="transform: translate(-65px, 11px);"
                                class="material-symbols-outlined"
                                (click)="clearSearch($event, false)"
                                *ngIf="menteeSearchQuery"
                            >
                                close
                            </span>
                            <span
                                class="material-symbols-outlined search-icon"
                                (click)="searchMenteesView()"
                            > search </span>
                        </div>
                        <div class="export">
                            <button (click)="exportTrainingData(false)">
                                <i class="iconplus mr-1">
                                <span class="material-symbols-outlined"> download </span>
                                </i>
                                <span class="btn-create"> Export</span>
                            </button>
                        </div>
                    </div>
                    <div class="table-section">
                        <mat-table [dataSource]="menteeViewDataSource" *ngIf="!isMenteeViewLoading">
                            <ng-container matColumnDef="mentorName">
                                <mat-header-cell *matHeaderCellDef> Mentor Name </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <div
                                        class="mat-cell truncateValue"
                                        [ngbTooltip]="projectNameTooltip"
                                        tooltipClass="custom_tooltip"
                                        triggers="manual"
                                        #tooltip="ngbTooltip"
                                        (mouseleave)="tooltip.close()"
                                        (mouseover)="tooltip.open()"
                                    >
                                        <ng-template #projectNameTooltip class="custom_tooltip">
                                            {{ element.mentorName }}
                                        </ng-template>
                                        {{ element.mentorName }}
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="trainingName">
                                <mat-header-cell *matHeaderCellDef> Training Name </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <div
                                        class="mat-cell truncateValue"
                                        [ngbTooltip]="projectNameTooltip"
                                        tooltipClass="custom_tooltip"
                                        triggers="manual"
                                        #tooltip="ngbTooltip"
                                        (mouseleave)="tooltip.close()"
                                        (mouseover)="tooltip.open()"
                                    >
                                        <ng-template #projectNameTooltip class="custom_tooltip">
                                            {{ element.trainingName }}
                                        </ng-template>
                                        {{ element.trainingName }}
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="menteeHours">
                                <mat-header-cell *matHeaderCellDef> Mentee Hours </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <div
                                        class="mat-cell truncateValue"
                                        [ngbTooltip]="projectNameTooltip"
                                        tooltipClass="custom_tooltip"
                                        triggers="manual"
                                        #tooltip="ngbTooltip"
                                        (mouseleave)="tooltip.close()"
                                        (mouseover)="tooltip.open()"
                                    >
                                        <ng-template #projectNameTooltip class="custom_tooltip">
                                            {{ element.hoursSpent }}
                                        </ng-template>
                                        {{ element.hoursSpent }}
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="mentorHours">
                                <mat-header-cell *matHeaderCellDef> Mentor Hours </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <div
                                        class="mat-cell truncateValue"
                                        [ngbTooltip]="projectNameTooltip"
                                        tooltipClass="custom_tooltip"
                                        triggers="manual"
                                        #tooltip="ngbTooltip"
                                        (mouseleave)="tooltip.close()"
                                        (mouseover)="tooltip.open()"
                                    >
                                        <ng-template #projectNameTooltip class="custom_tooltip">
                                            {{ element.mentorHours }}
                                        </ng-template>
                                        {{ element.mentorHours }}
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="completedStatus">
                                <mat-header-cell *matHeaderCellDef> % Completed </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <div
                                        class="mat-cell truncateValue"
                                        [ngbTooltip]="projectNameTooltip"
                                        tooltipClass="custom_tooltip"
                                        triggers="manual"
                                        #tooltip="ngbTooltip"
                                        (mouseleave)="tooltip.close()"
                                        (mouseover)="tooltip.open()"
                                    >
                                        <ng-template #projectNameTooltip class="custom_tooltip">
                                            {{ element.completedPercentage }}
                                        </ng-template>
                                        {{ element.completedPercentage }}
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="status">
                                <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <div
                                        class="mat-cell truncateValue"
                                        [ngbTooltip]="projectNameTooltip"
                                        tooltipClass="custom_tooltip"
                                        triggers="manual"
                                        #tooltip="ngbTooltip"
                                        (mouseleave)="tooltip.close()"
                                        (mouseover)="tooltip.open()"
                                    >
                                        <ng-template #projectNameTooltip class="custom_tooltip">
                                            {{ element.status }}
                                        </ng-template>
                                        {{ element.status }}
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="startDate">
                                <mat-header-cell *matHeaderCellDef> Start Date </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <div
                                        class="mat-cell truncateValue"
                                        [ngbTooltip]="projectNameTooltip"
                                        tooltipClass="custom_tooltip"
                                        triggers="manual"
                                        #tooltip="ngbTooltip"
                                        (mouseleave)="tooltip.close()"
                                        (mouseover)="tooltip.open()"
                                    >
                                        <ng-template #projectNameTooltip class="custom_tooltip">
                                            {{ element.startDate }}
                                        </ng-template>
                                        {{ element.startDate }}
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="endDate">
                                <mat-header-cell *matHeaderCellDef> End Date </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <div
                                        class="mat-cell truncateValue"
                                        [ngbTooltip]="projectNameTooltip"
                                        tooltipClass="custom_tooltip"
                                        triggers="manual"
                                        #tooltip="ngbTooltip"
                                        (mouseleave)="tooltip.close()"
                                        (mouseover)="tooltip.open()"
                                    >
                                        <ng-template #projectNameTooltip class="custom_tooltip">
                                            {{ element.endDate }}
                                        </ng-template>
                                        {{ element.endDate }}
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="actions">
                                <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <a class="action-link" (click)="openLogHoursDialog(false, element)">
                                        <span class="material-symbols-outlined"> edit </span> Log Hours
                                    </a>
                                </mat-cell>
                            </ng-container>

                            <mat-header-row *matHeaderRowDef="menteeViewColumns; sticky: true"></mat-header-row>
                            <mat-row
                                [class.odd]="i % 2 == 1"
                                [class.even]="i % 2 == 0"
                                *matRowDef="let row; columns: menteeViewColumns; let i = index;"
                            >
                            </mat-row>
                        </mat-table>
                        <div
                            *ngIf="!menteeViewDataSource.length && !isMenteeViewLoading"
                            style="text-align: center; margin: 10px 0;"
                        >
                            No Records Found
                        </div>
                        <mat-paginator
                            #menteePaginator
                            [length]="filteredMenteeViewList.length"
                            [pageSize]="menteeViewTo"
                            [pageSizeOptions]="[10, 20, 50, 100]"
                            (page)="onPageChange($event, false)"
                        ></mat-paginator>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>